

export function NodejsIcon({ className }: { className?: string }) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
    >
      <path d="M14.914 1.023l-3.087 1.774v3.535l3.087-1.774zm3.084 1.774l-3.085 1.774v3.535l3.085-1.774zm0 14.156l-3.085 1.774V22.26l3.085-1.774zm-3.084 1.774l-3.087 1.774v3.535l3.087-1.774zm-9.255-3.548l-3.085 1.774v3.535l3.085-1.774zm-3.085-1.774l-3.087 1.774v3.535l3.087-1.774zm0-7.078l3.087 1.774v3.535L2.574 9.63zm3.085-1.774l3.087 1.774v3.535L5.659 7.856zm3.087-1.774l3.085 1.774v3.535L8.746 6.082zm6.168-3.548l-3.087 1.774v3.535l3.087-1.774zm0 7.078l-3.087 1.774v3.535l3.087-1.774zm3.085 1.774l-3.085 1.774v3.535l3.085-1.774zm3.085-5.304l-3.085 1.774v3.535l3.085-1.774zm0 7.078l-3.085 1.774v3.535l3.085-1.774zm-3.085 1.774l-3.085 1.774v3.535l3.085-1.774zM11.827 6.326l-3.087 1.774v3.535l3.087-1.774zm0 7.078l-3.087 1.774v3.535l3.087-1.774zm-3.087-1.774l-3.085 1.774v3.535l3.085-1.774z" />
    </svg>
  );
}
